import { defineStore } from 'pinia'
import { Itinerary2, TRIP_PHASE } from '~/models/Itinerary'

export const useProfileTrips = defineStore('profileTrips', () => {
	const lastUpdatedTrip = ref<Itinerary2>()
	const trips = ref<Record<string, Itinerary2>>({})
	const tripsByPhase = ref<Record<any, string[]>>({
		[TRIP_PHASE.ALL]: [],
		[TRIP_PHASE.NEXT]: [],
		[TRIP_PHASE.PAST]: [],
		[TRIP_PHASE.NO_DATES]: [],
	})

	const addTrips = (phase: TRIP_PHASE, newTrips: Itinerary2[]): void => {
		newTrips.forEach((trip) => (trips.value[trip.id!] = trip))
		const tripsIds: string[] = newTrips.map((trip: Itinerary2) => trip.id!)
		tripsByPhase.value[phase]?.push(...tripsIds)
	}

	const getTrips = (phase: TRIP_PHASE): Itinerary2[] => {
		if (!tripsByPhase.value[phase]) return []
		return tripsByPhase.value[phase].map((tripId: string) => {
			return trips.value[tripId]
		}) as Itinerary2[]
	}

	const addLastUpdatedTrip = (trip: Itinerary2) => {
		lastUpdatedTrip.value = trip
	}

	const getLastUpdatedTrip = () => {
		return lastUpdatedTrip.value
	}

	const resetAll = () => {
		resetLastUpdatedTrip()
		resetTrips()
	}

	const resetLastUpdatedTrip = () => {
		lastUpdatedTrip.value = undefined
	}

	const resetTrips = () => {
		trips.value = {}
		tripsByPhase.value = {
			[TRIP_PHASE.ALL]: [],
			[TRIP_PHASE.NEXT]: [],
			[TRIP_PHASE.PAST]: [],
			[TRIP_PHASE.NO_DATES]: [],
		}
	}

	return {
		resetAll,
		addTrips,
		addLastUpdatedTrip,
		getTrips,
		getLastUpdatedTrip,
		resetTrips,
		resetLastUpdatedTrip,
	}
})
